<template>
  <div class="box" ref="box"
    :style="[{ position: styleInfo.slideEffect == 'suspension' && !navFree ? 'fixed' : 'relative' }, navThemeObject, styleObject]">
    <div class="left-nav-collapse" v-if="styleInfo.layoutPos === 'left' && isAppenLi"
      @click="$emit('collapse', !isCollapse)">
      <i class="iconfont icon-a-zhankai2" :class="isCollapse ? '' : 'rotate'" />
    </div>
    <template v-if="styleInfo.layoutPos === 'left' && styleInfo.useFun && styleInfo.useFun.includes('topBtn')">
      <topBtn :info="topData && topData.topBtnInfo" @to-nav="toBtnNav" @open-appDialog="openAppDialog"
        @open-ability="customOpenAbility($event, 'nav')" @open-dictionary="openDictionary"
        @openAppInitiate="openAppInitiate" @custom-scene="customScene" />
    </template>
    <div ref="top" class="box-top"
      :style="[{ height: (topData && topData.h) + 'px' }, styleInfo.layoutPos === 'left' ? getTopNavBg : topBgInfo]">
      <!-- Logo -->
      <div data-name="logo" class="logo" ref="logo" v-show="topData.list.logo.show" :style="{
        left: navFree ? `${getItemPos(topData.list.logo.x)}px` : `${(topData.list.logo.x / winWidth) * 100}%`,
        top: topData.list.logo.y + 'px',
        width: topDataList.name.show && topDataList.slogan.show && (topDataList.slogan && topDataList.slogan.show) ? topData.list.logo.w + 'px' : 'auto',
        height: topData.list.logo.h + 'px',
      }" v-if="styleInfo.layoutPos !== 'left'">
        <div ref="logo-img" class="logo-img" :class="topDataList.name.show || topDataList.slogan.show ? '' : 'boxAuto'"
          v-if="topDataList.img.show" :style="{
            width: topDataList.img.w + 'px',
            height: topDataList.img.h + 'px',
          }">
          <el-image :src="topDataList.img.url.includes('http') ? topDataList.img.url : $url + topDataList.img.url">
          </el-image>
        </div>
        <div class="logo-text"
          v-if="topDataList.name.show || topDataList.slogan.show || (topDataList.slogan && topDataList.slogan.show)">
          <div v-if="topDataList.name.show || (topDataList.slogan && topDataList.slogan.show)"
            style="display: flex;align-items: center;">
            <span v-if="topDataList.name.show" :style="topDataList.name.font">{{ topDataList.name.text }}</span>
            <span v-if="topDataList.subscript && topDataList.subscript.show" class="logo-subscript"
              :style="topDataList.subscript && topDataList.subscript.font">{{ topDataList.subscript &&
                topDataList.subscript.text }}</span>
          </div>
          <div v-if="topDataList.slogan.show">
            <span ref="logo-slogan" :style="topDataList.slogan.font">{{ topDataList.slogan.text }}</span>
          </div>
        </div>
      </div>
      <div class="switch" ref="switch" v-if="schoolList.length > 1" :style="{
        // left: (topData.list.switch.x / winWidth) * 100 + '%',
        left: navFree ? `${getItemPos(topData.list.switch.x)}px` : `${(topData.list.switch.x / winWidth) * 100}vw`,
        top: topData.list.switch.y + 'px',
        width: topData.list.switch.w + 'px',
        height: topData.list.switch.h + 'px',
      }" @click="changeSchool">
        <img style="height: 100%; width: 100%" :src="hadnleSwitch" />
      </div>
      <!-- 搜索框 -->
      <div class="inputArea" v-show="typeShow === 1 && topData.list.search.show" :style="{
        left: navFree ? `${getItemPos(topData.list.search.x)}px` : `${(topData.list.search.x / winWidth) * 100}vw`,
        top: topData.list.search.y + 'px',
      }">
        <el-input placeholder="搜索应用" v-model="searchInput" clearable @keyup.enter="searchMoreFun"
          :style="topData.list.search.font">
          <template #prefix>
            <i class="iconfont icon-sousuo"></i>
          </template>
        </el-input>
        <el-button size="small" :style="{
          background: themeColor,
        }" @click="searchMoreFun" type="primary">
          <i class="iconfont icon-sousuo"></i>
        </el-button>
      </div>
      <div data-name="user" class="user" v-show="topData.list.user.show" :style="{
        left: navFree ? `${getItemPos(topData.list.user.x)}px` : `${(topData.list.user.x / winWidth) * 100}vw`,
        top: topData.list.user.y + 'px',
      }">
        <!-- 通知 -->
        <div class="remind" style="position: relative" v-if="!openWebsite">
          <el-popover v-model:visible="isPopValue" trigger="click" placement="bottom-end" popper-class="door-popper"
            transition="el-zoom-in-top" width="auto">
            <template #reference>
              <div v-if="openRole && !upaceid && !isCustomDesk" class="open-door" title="切换门户">
                <i :style="{
                  color: styleInfo.iconColor === 'deepColor' ? '#333' : '#FFF',
                }" class="WSiconfont WSicon-tuimen2 open-door-img" v-if="rolesList.length > 1" />
              </div>
            </template>
            <el-radio-group v-model="customId" @change="handleRadioChange"
              style="display: flex; flex-wrap: wrap; flex-direction: column">
              <el-radio style="width: 100%; color: #fff" v-for="item in rolesList" :key="item.customDeskId"
                :label="'' + item.customDeskId">{{ item.name }}</el-radio>
            </el-radio-group>
          </el-popover>
          <schoolNews layout="1" :iconColor="styleInfo.iconColor === 'deepColor' ? '#333' : '#FFF'" />
        </div>
        <div class="userArea" v-if="getLoginText">
          <div class="userArea-toLogin" v-if="openWebsite && !sysUserMsg">
            <a @click="toLogin" :style="[topData.list.user.font, { background: themeColor }, { color: '#fff' }]"
              class="userArea-toLogin-btn">
              {{ getLoginText }}
            </a>
          </div>
          <el-popover v-else placement="bottom-start" popper-class="userPopover" width="200" trigger="click"
            style="top: 35px !important">
            <!-- 前台工具栏 -->
            <div class="popoverArea" v-if="typeShow === 1">
              <template v-if="openVip">
                <template v-if="isVip">
                  <div class="vip-area" @click="goVipCenter">
                    <span class="tag">{{memberInfo.level}}会员</span>
                    <div class="time">剩余时长：<span>{{memberInfo.expireDate}}</span></div>
                  </div>
                  <p class="btn-vip" @click="goVip">续费/升级会员</p>
                </template>
                <p class="btn-vip" v-else @click="goVip">开通会员</p>
              </template>
              <p @click="goAccount">账号管理</p>
              <p @click="$emit('open-admin')" v-if="adminload === 0 && sysUserMsg && sysUserMsg.isadmin < 3">
                后台管理
              </p>
              <p @click="$emit('open-space')" v-if="spaceAppenComp">
                组织空间
              </p>
              <p @click="$openAdmin({ path: '/cust/main/upaceMain' }, { isNewTab: true })" v-if="upaceAppen">
                个人空间
              </p>
              <p @click="$emit('change-user')">
                切换账号
              </p>
              <!-- <p
                @click="
                  $router.push({ path: '/clientSide/setUpThe/changePassword' })
                "
              >
                修改密码
              </p> -->
              <!-- <p v-if="openRole" @click="showRoleDialog">切换门户</p> -->
              <p @click="logout">退出账号</p>
            </div>
            <!-- 后台工具栏 -->
            <div class="popoverArea" v-if="typeShow === 2">
              设置
              <p @click="$router.push({ path: '/index' })">客户端查看</p>
              <p @click="logout">退出登录</p>
            </div>
            <!-- 点击切换 -->
            <template #reference>
              <div style="cursor: pointer;display: flex;align-items: center;">
                <img :src="dealDefaultAvatar" style="width: 32px;height: 32px;border-radius: 100%;margin-right: 3px;">
                <div class="name" :style="topData.list.user.font">
                  {{ sysUserMsg.name }}
                </div>
                <span v-if="openVip && isVip" class="tag">{{memberInfo.level}}</span>
              </div>
            </template>
          </el-popover>
        </div>
      </div>
      <div data-name="navbar" v-show="topData.list.navbar.show && styleInfo.layoutPos !== 'left'" class="navbarParent"
        :style="{
          left: navFree ? `${getItemPos(topData.list.navbar.x)}px` : `${(topData.list.navbar.x / winWidth) * 100}%`,
          top: topData.list.navbar.y + 'px',
          width: `${topData.list.navbar.w / contentInfo.pageWidth * 100}%`,
          height: topData.list.navbar.h + 'px',
          backgroundColor: styleInfo.layoutPos === 'left' ? '' : topData.list.navbar.bgColor,
        }">
        <div class="navbox" ref="navbox">
          <span v-show="navbarIsScroll" class="back" @click="changeTab('left')"><i
              class="iconfont icon-fanhui1"></i></span>
          <div class="navbar-mask" ref="navbar-mask">
            <ul ref="navbar" class="navbar" :class="topData.list.navbar.style"
              :style="[topData.list.navbar.font, { '--textSize': `${parseInt(topData.list.navbar.font.fontSize) - 2}px`, transform: `translateX(${transformX}px)` }]">
              <template v-for="(item, i) in topData.list.navbar.list">
                <li v-if="item.isShow" :key="i" class="navbar-mask-li"
                  :style="[subTitleStyle, { padding: `0 ${navPd}px` }]"
                  :class="[item.id === activeTopMenu && !isNews ? `active ${styleInfo.navStyle || 'colorBlock'}` : '', `navbar-mask-li-${styleInfo.navStyle || 'colorBlock'}`, isAppenDrop(item) && styleInfo.childStyle === 'style1' ? 'arrow-top' : '']"
                  ref="column" @mouseleave.self="mouseleave(i)" @mouseenter.self="mouseenter(i)">
                  <a href="javascript:;" @click="active(i, item)" @mouseover="mouseover(i)" @mouseout="mouseout(i)"
                    :style="styleObject" style="flex-direction: column;">
                    <label style="cursor: pointer;" class="navbar-maintitle">{{ item.column }}</label>
                    <label style="cursor: pointer;" v-if="isSubTitle" class="navbar-subtitle">{{ item.subtitle
                      }}</label>
                  </a>
                  <div v-if="isAppenDrop(item)" style="height: 30%;width: 100%;"></div>
                  <div v-if="isAppenDrop(item)" @transitionend.self="transitionend" @mouseleave="mouseleave(i)"
                    @mouseenter="mouseNaventer(i)" class="navson-drop" :ref="`drop-${i}`"
                    :class="`drop-${styleInfo.childStyle}`">
                    <div class="navson-drop-item" :style="topData.list.navbar.font"
                      :class="citem.id === activeTopChildMenu ? 'active-nav navson-tile-item' : 'navson-tile-item'"
                      v-show="citem.isShow" @click="active(i, citem)" v-for="(citem, cidx) in item.lists" :key="cidx">
                      {{ citem.column }}
                    </div>
                  </div>
                </li>
              </template>
            </ul>
          </div>
          <span v-show="navbarIsScroll" class="next" @click="changeTab('right')"><i
              class="iconfont icon-qianjin"></i></span>
        </div>
      </div>
    </div>
    <div v-if="styleInfo.childDirection !== 'drop'" class="navson" ref="navson" :style="[
      { height: topData.list.navbar.h + 'px' },
      topData.list.navbar.font,
    ]">
      <ul @mouseover="mouseover(columnIndex)" @mouseout="mouseout()">
        <template v-for="(item, i) in topData.list.navbar.temArr">
          <li v-if="item.isShow" :key="i" :class="activeTopChildMenu === item.id ? 'active-nav' : ''">
            <a href="javascript:;" @click="active(i, item)" :style="styleObject">{{ item.column }}</a>
          </li>
        </template>
      </ul>
    </div>
    <div v-if="topData.list.navbar.style === 'fill-dark-tile'" class="mask" ref="mask" @mouseover="mouseover(-1)"
      @mouseout="mouseout()"></div>
    <app-dialog :dialogInfo="dialogInfo"></app-dialog>
    <spaceChoose v-model:isView="openSpaceChoose" :spaceList="curSpaceList" @goSpace="goSpace" :isCopm="true" />
    <upOption ref="upOption" />
    <app-dialog
      :dialogInfo="{ dialogName: openInput.name, isVisible: openInput.isVisible, dialogWidth: '80%', dialogHeight: '85vh' }"
      :iId="openInput.iId" v-model:isDetail="openInput.isDetail" :appId="openInput.approvalId"
      v-model:addInputShow="openAddInputShow" :coverVal="openInput.search" :datatype="openInput.datatype"
      @close="doorUpCloe" />
    <vipPay v-model:isView="vipPayShow" />
  </div>
</template>

<script>
import navMixins from './navMixins'
import { getRadioBgInfo } from '@/components/schoolInstrument/mixins/utils'
export default {
  name: "layoutOne",
  mixins: [navMixins],
  computed: {
    dealDefaultAvatar() {
      let avatar = this.userMsg.avatar
      let url = ''
      if (avatar) {
        if (avatar.includes('img-')) {
          url = this.$imgurl + avatar
        } else {
          const list = avatar.split('/')
          const num = list[list.length - 1]
          let format = `${num}.jpg`
          if (Number(num) >= 36) {
            format = `${num}.svg`
          }
          url = `https://bigdata.topeti.com/PCRepository/middleground/avatar/${format}`
        }
      } else {
        if (this.userMsg.sex && this.userMsg.sex === '女') {
          url = 'https://bigdata.topeti.com/PCRepository/middleground/avatar/16.jpg'
        } else {
          url = 'https://bigdata.topeti.com/PCRepository/middleground/avatar/23.jpg'
        }
      }
      return url
    },
    isSubTitle() {
      let falg = false
      const idx = this.topData.list.navbar.list.findIndex(item => item.subtitle)
      if (idx !== -1) falg = true
      return falg
    },
    subTitleStyle() {
      const UNDERLINE = '--underline-'
      const obj = {
        [UNDERLINE]: '-7px'
      }
      if (this.isSubTitle) {
        obj[UNDERLINE] = '-30px'
      }
      return obj
    },
    topDataList() {
      return this.topData.list.logo.list
    },
    getTopNavBg() {
      console.log(getRadioBgInfo(this.styleInfo.topBgInfo), 'getRadioBgInfo(this.styleInfo.topBgInfo)')
      return getRadioBgInfo(this.styleInfo.topBgInfo, { defaultColor: '#fff' })
    },
    topBgInfo() {
      return getRadioBgInfo(this.styleInfo.backGroundInfo, { defaultColor: '#fff', bgImgLayout: this.styleInfo.bgImgLayout })
    }
  },
  props: {
    navPd: {
      type: Number,
      default: 25
    }
  },
  watch: {
    checkObj: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.topData.list.navbar.list = val.list
        }
      },
    },
  },
  data() {
    return {
      // 浏览器宽度
      winWidth: null,
      columnIndex: 0,
      navCur: null,
      navbarPage: 1,
      deviation: [],
      topData: {
        name: 'layout1',
        tem: null,
        pageWidth: document.body.clientWidth,
        h: 50,
        bgColor: 'white',
        bgImg: '',
        handles: ['bm'],
        isShowColumnManage: false,
        items: [
          {
            name: 'logo',
            value: 'logo'
          },
          {
            name: '导航栏',
            value: 'navbar'
          },
          {
            name: '搜索',
            value: 'search'
          },
          {
            name: '用户',
            value: 'user'
          }
        ],
        list: {
          logo: {
            // 是否显示
            show: true,
            // 编辑模态框是否开启
            editModalShow: false,
            // x轴偏移位置
            x: document.body.clientWidth * 0.0234375,
            // y轴偏移位置
            y: 5.5,
            // 高度
            h: 39,
            // 宽度
            w: 135,
            // 缩放的按钮显示
            handles: ['br'],
            list: {
              img: {
                show: true,
                h: 33,
                w: 33,
                url:
                  'https://bigdata.topeti.com/PCRepository/middleground/default-logo.png'
              },
              name: {
                show: true,
                text: '请输入标题',
                edit: true,
                // 字体样式
                font: {
                  fontSize: '18px', // 字体大小
                  fontFamily: '微软雅黑', // 字体样式
                  fontWeight: 'normal', // 是否加粗
                  fontStyle: 'normal', // 是否斜体
                  textDecoration: 'none', // 是否下划线
                  color: '#333', // 选择的颜色
                  textAlign: 'center' // 位置排版
                }
              },
              slogan: {
                show: true,
                text: '请输入简短说明',
                edit: false,
                font: {
                  fontSize: '10px', // 字体大小
                  fontFamily: '微软雅黑', // 字体样式
                  fontWeight: 'normal', // 是否加粗
                  fontStyle: 'normal', // 是否斜体
                  textDecoration: 'none', // 是否下划线
                  color: '#333', // 选择的颜色
                  textAlign: 'center' // 位置排版
                }
              }
            }
          },
          navbar: {
            show: true,
            editModalShow: false,
            element: '',
            h: 50,
            w: '278',
            y: 0,
            x: (document.body.clientWidth - 1092) * 0.5 + 360,
            style: 'fill-dark-tile', // fill-dark-tile
            handles: ['br'],
            font: {
              fontSize: '16px', // 字体大小
              fontFamily: '微软雅黑', // 字体样式
              fontWeight: 'normal', // 是否加粗
              fontStyle: 'normal', // 是否斜体
              textDecoration: 'none', // 是否下划线
              color: '#333', // 选择的颜色
              textAlign: 'center' // 位置排版
            },
            list: this.checkObj,
            temArr: []
          },
          search: {
            show: true,
            editModalShow: false,
            h: 30,
            w: 258,
            x: (document.body.clientWidth - 1241.82) * 0.8 + 800,
            y: 8,
            handles: ['br'],
            font: '',
            button: {
              w: 60,
              h: 32
            }
          },
          user: {
            show: true,
            editModalShow: false,
            x: document.body.clientWidth - 165 - 45,
            y: 0,
            handles: ['br'],
            font: {
              fontSize: '16px', // 字体大小
              fontFamily: '微软雅黑', // 字体样式
              fontWeight: 'normal', // 是否加粗
              fontStyle: 'normal', // 是否斜体
              textDecoration: 'none', // 是否下划线
              color: '#333', // 选择的颜色
              textAlign: 'center' // 位置排版
            }
          },
          switch: {
            // x轴偏移位置
            x: document.body.clientWidth * 0.0234375 + 135,
            // y轴偏移位置
            y: 16,
            // 高度
            h: 18,
            // 宽度
            w: 18,
            // 缩放的按钮显示
            handles: ['br']
          },
        }
      },
    };
  },
  methods: {
    getItemPos(w) {
      if (this.topData.pageWidth === this.winWidth) {
        return w
      }
      const res = (w * this.topData.pageWidth) / this.winWidth
      return res
    },
    handleNavInside(query, path, openFun, dialogInfo, name) {
      const spaceid = this.$route.query.spaceid
      const upaceid = this.$route.query.upaceid
      if (spaceid) {
        query.spaceid = spaceid
        query.space = true
      }
      else if (upaceid) {
        query.upaceid = upaceid
        query.upace = true
      }
      if (path === '/index') {
        delete query.spaceid
        delete query.space
        delete query.upaceid
        delete query.upace
      }
      if (this.curType === 'platformInside' && query.spaceid) {
        delete query.spaceid
        delete query.space
      }
      else if (this.curType === 'platformInside' && query.upaceid) {
        delete query.upaceid
        delete query.upace
      }
      if (openFun === 'old') {
        this.$router.push({
          path,
          query
        });
      } else if (openFun === 'new') {
        query.navshow = false
        const route = this.$router.resolve({
          path,
          query
        })
        window.open(route.href, '_blank')
      } else {
        query.navshow = false
        this.dialogInfo.openType = openFun
        const route = this.$router.resolve({
          path: "/clientSide/oaFrame/oaFrame",
          query
        })
        this.handleDialog(route.href, dialogInfo, name)
      }
    },
    // 二级导航显示/隐藏
    mouseover(index) {
      if (this.styleInfo.childDirection === 'drop') return
      this.topData.list.navbar.temArr = []
      this.columnIndex = index
      if (this.topData.list.navbar.list[this.columnIndex].lists.length > 0) {
        if (index !== -1) {
          this.topData.list.navbar.temArr = this.topData.list.navbar.list[
            index
          ].lists
        }
      } else {
        return
      }
      if (this.topData.list.navbar.style === 'fill-dark-tile') {
        this.$refs.navson.style.maxHeight = '50px'
        this.$refs.mask.style.height = '50px'
      } else {
        const rect = this.$refs.column[index].getBoundingClientRect()
        this.$refs.navson.style.maxHeight = '273px'
        this.$refs.navson.style.left = rect.left + 'px'
        this.$refs.navson.style.top = rect.top + rect.height + 'px'
      }
    },
    mouseout() {
      if (this.styleInfo.childDirection === 'drop') return
      if (this.topData.list.navbar.style === 'fill-dark-tile') {
        this.$refs.navson.style.maxHeight = '0px'
        this.$refs.mask.style.height = '0px'
      } else {
        this.$refs.navson.style.maxHeight = '0px'
      }
    },
    // 初始化设置背景
    setBg() {
      const navData = this.topData.list.navbar.list;
      const pathName = window.location.pathname;
      for (let i = 0; i < navData.length; i++) {
        if (pathName === '/index' && navData[i].column === '首页' || pathName === '/clientSide/oaExamine' && navData[i].column === '应用中心' || pathName === '/clientSide/workbench' && navData[i].column === '发现') {
          this.navCur = i;
          break;
        }
        else {
          this.navCur = 0;
        }
      }
      this.winWidth = this.topData.pageWidth;
    }
  },
}
</script>
<style lang="scss" scoped>
.box {
  $navtheme-color: var(--navtheme-color);
  $main-color: var(--background-color);
  position: relative;

  .left-nav-collapse {
    position: absolute;
    left: 20px;
    top: calc(50% - 13px);
    z-index: 99;
    height: 26px;
    padding-right: 32px;
    border-right: solid 1px #F0EFF2;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .icon-a-zhankai2 {
      font-size: 18px;
      color: #000000;
      cursor: pointer;
      display: inline-block;
      transition: .3s;
    }

    .rotate {
      transform: rotate(180deg);
    }
  }

  .box-top {
    .navbarParent {
      .navbox {
        .navbar-mask {
          overflow-x: clip;
          overflow-y: visible;

          .arrow-top {
            &:hover {
              &::after {
                opacity: 1;
              }
            }
          }

          .navbar-mask-li {
            padding: 0 25px;
            cursor: pointer;
            position: relative;

            .navbar-subtitle {
              font-size: var(--textSize);
              height: 19px;
            }

            &::after {
              content: '';
              position: absolute;
              display: block;
              width: 0;
              height: 0;
              opacity: 0;
              top: calc(130% - 9px);
              left: calc(50% - 10px);
              transition: .3s;
              z-index: 999;
              border-right: 10px solid transparent;
              border-bottom: 10px solid rgba(255, 255, 255, 0.8);
              border-left: 10px solid transparent;
            }

            .navson-drop {
              position: absolute;
              width: 100%;
              left: 0;
              -webkit-transform: translate3d(0, 0, 0);
              -moz-transform: translate3d(0, 0, 0);
              -ms-transform: translate3d(0, 0, 0);
              transform: translate3d(0, 0, 0);
              transition: .3s;
              transition-property: height;
              height: 0;
              overflow: hidden;

              &-item {
                box-sizing: border-box;
                padding: 12px 25px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: #000;
                transition: .3s;
                cursor: pointer;
                font-weight: 400;
                font-size: 14px;
              }
            }

            .drop-style1 {
              top: 130%;
              background-color: rgba(255, 255, 255, 0.8);
              left: 50%;
              transform: translateX(-50%);
              max-width: 400%;
              width: initial;

              .navson-drop-item {
                color: #333 !important;

                &:hover {
                  color: $main-color !important;
                }
              }

              .active-nav {
                color: $main-color !important;
              }
            }

            .drop-style2 {
              background-color: $main-color;

              .active-nav {
                background-color: #3333333d;
                color: #fff !important;
              }

              .navson-drop-item {
                &:hover {
                  background-color: #3333333d;
                  color: #fff !important;
                }
              }
            }
          }

          .navbar-mask-li-colorBlock {
            &:hover {
              background-color: $navtheme-color;
              color: #fff;
            }
          }

          .colorBlock {
            background-color: $navtheme-color;
            color: #fff;
          }

          .navbar-mask-li-underline {
            &:hover {
              a {
                position: relative;
                background-color: initial;
                color: $navtheme-color;
                padding: 0;
                width: 100%;
                text-align: center;

                .navbar-maintitle {
                  position: relative;

                  &::after {
                    content: '';
                    position: absolute;
                    transform: translateX(-50%);
                    left: 50%;
                    width: 28px;
                    height: 3px;
                    bottom: var(--underline-);
                    background-color: $navtheme-color;
                  }
                }
              }
            }
          }

          .underline {
            a {
              position: relative;
              background-color: initial;
              color: $navtheme-color;
              padding: 0;
              width: 100%;
              text-align: center;
              cursor: pointer;

              .navbar-maintitle {
                position: relative;

                &::after {
                  content: '';
                  position: absolute;
                  transform: translateX(-50%);
                  left: 50%;
                  width: 28px;
                  height: 3px;
                  bottom: var(--underline-);
                  background-color: $navtheme-color;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.el-popper.el-tooltip.door-popper {
  background: #505050;
  border: none;

  .el-radio-group {
    .el-radio {
      height: 21px;
      margin-right: 0;
    }
  }

  .el-popper__arrow:before {
    border-bottom-color: #505050 !important;
    border-right-color: #505050 !important;
    background-color: #505050;
  }
}
</style>
<style lang="scss" scoped>
.box {
  z-index: 9;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  transition: all 0.3s;
}

.popoverArea p {
  display: inline-block;
  width: 100%;
  text-align: center;
  height: 35px;
  line-height: 35px;
  cursor: pointer;

  &:hover {
    background-color: #f1f8ff;
  }
}

.popoverArea .vip-area {
  height: 85px;
  padding: 13px 0 0 14px;
  margin-bottom: 6px;
  box-sizing: border-box;
  border-radius: 6px;
  background: url("https://bigdata.topeti.com/PCRepository/mainPlatform/vip/bg-card.png") no-repeat 100% 100%;
  cursor: pointer;
  .tag {
    font-size: 16px;
    color: #E3782E;
  }

  .time {
    padding-top: 23px;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #784928;

    span {
      padding-left: 10px;
      color: #FE6678;
    }
  }
}

.popoverArea .btn-vip {
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  font-size: 14px;
  color: #C36A2D;
  text-align: center;
  background: linear-gradient(270deg, rgba(255, 199, 106, 1) 0%, rgba(251, 218, 157, 1) 100%);
}

.box-top {
  position: relative;
  width: 100% !important;
  z-index: 9;
  cursor: default;
  // background: #fff;
  background-size: cover;
  background-repeat: no-repeat;
  transition: all 0.3s;
}

.boxAuto {
  width: 100% !important;
  height: 100% !important;
}

.box>div.vdr {
  position: relative;
}

.box>div.navson.vdr {
  position: absolute;
}

.logo {
  position: absolute;
  box-sizing: border-box;
  vertical-align: top;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;

  .logo-text {
    display: inline-block;
    margin-left: 4px;
    // margin-top: 8px;
    vertical-align: top;
    line-height: 18px;

    >div:first-child {
      color: #333333;
      font-size: 18px;
    }

    >div:last-child {
      color: #333333;
      font-size: 10px;
    }

    .logo-subscript {
      margin-left: 10px;
      padding: 5px 8px;
      border-radius: 8px 8px 8px 0;
      display: inline-block;
    }
  }
}

.open-door {
  height: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  left: -20px;
  top: 0;
  z-index: 99;

  &-img {
    cursor: pointer;
    font-size: 24px !important;
  }
}

.logo-img {
  display: inline-block;
  vertical-align: top;
  overflow: hidden;

  ::v-deep .el-image {
    width: 100%;
    height: 100%;

    img {
      width: auto;
    }
  }
}

.switch {
  position: absolute;
  left: 140px;
  // background-image: url("https://bigdata.topeti.com/PCRepository/middleground/home/icon/header/switch-lightColor.svg");
  background-size: cover;
  background-repeat: no-repeat;
  cursor: pointer;
}

.search {
  position: absolute;
  width: 258px;
  height: 32px;
}

.navbarParent {
  position: absolute;
  left: 30%;
}

.navbox {
  position: relative;
  width: 100%;
  height: 100%;

  .navbar-mask {
    width: 100%;
    height: 100%;
  }

  .navbar {
    white-space: nowrap;
    transition: all 0.3s;
    height: 100%;
    display: inline-block;
    color: #333333;
    font-size: 16px;

    li {
      display: inline-block;
    }
  }

  span {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 50%;
    display: inline-block;
    background-color: rgba($color: #000000, $alpha: 0.3);
    width: 20px;
    height: 20px;
    cursor: pointer;
    z-index: 9;
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      color: white;
      font-size: 10px;
    }
  }

  .back {
    left: -20px;
  }

  .next {
    right: -20px;
  }
}

.navbar>li:first-child {
  margin-left: 0;
}

.navbar>li {
  height: 100%;
  position: relative;
}

.navbar>li>a {
  font-size: 16px;
  font-family: MicrosoftYaHei;
  height: 100%;
  display: flex;
  transition: all 0.4s;
  justify-content: center;
  align-items: center;
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  text-decoration: inherit;
  font-weight: inherit;
  line-height: inherit;
  text-align: inherit;
}

.navbar.line-top>li>a::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  width: 0%;
  height: 2px;
  background-color: #4e86ff;
  transition: all 0.3s;
}

.navbar.line-bottom>li>a::before {
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
  width: 0%;
  height: 2px;
  background-color: #4e86ff;
  transition: all 0.3s;
}

.navbar.line-top>.navbar.line-topli.active>a,
.navbar.line-top>li:hover>a,
.navbar.line-bottom>li.active>a,
.navbar.line-bottom>li:hover>a {
  color: #4e86ff;
}

.navbar.fill-light>li.active>a,
.navbar.fill-light>li:hover>a {
  background-color: #f2f2f2;
  color: #4e86ff;
}

// .navbar.fill-dark > li.active > a,
// .navbar.fill-dark > li:hover > a,
// .navbar.fill-dark-tile > li.active > a,
// .navbar.fill-dark-tile > li:hover > a {
//   background-color: #3333333d;
//   color: #fff;
// }
.navbar.fill-light>li.active>a,
.navbar.fill-light>li:hover>a {
  background-color: #f2f2f2;
  color: #4e86ff;
}

.navbar.line-top>li.active a::before,
.navbar.line-top>li:hover>a::before,
.navbar.line-bottom>li.active a::before,
.navbar.line-bottom>li:hover>a::before {
  width: 100%;
}

.navbar>li.active a,
.navbar>li:hover>ul {
  max-height: 400px;
}

.navbar>li>ul {
  position: absolute;
  left: 0;
  white-space: nowrap;
  border-radius: 4px;
  background-color: white;
  z-index: -1;
  max-height: 0;
  overflow: hidden;
  transition: all 0.8s;
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  text-decoration: inherit;
  font-weight: inherit;
  line-height: inherit;
  text-align: inherit;
}

.navbar>li>ul>li>a {
  display: inline-block;
  padding: 10px 26px;
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  text-decoration: inherit;
  font-weight: inherit;
  line-height: inherit;
  text-align: inherit;
  background-color: white;
  transition: all 0.2s;
}

.navbar>li>ul>li>a:hover {
  background-color: #4e86ff;
  color: white;
}

.inputArea {
  position: absolute;
  left: 65%;
  width: 258px;
  display: flex;
  align-items: center;
  height: 30px;
  line-height: 30px;

  ::v-deep .el-input__wrapper {
    border-radius: 4px 0 0 4px;
    border-right: none;
  }

  ::v-deep .el-button {
    width: 60px;
    height: 32px;
    background-color: #4e86ff;
    border: none;
    border-radius: 0 4px 4px 0;
    padding: 0;

    /*color: #ffffff;*/
    .iconfont {
      font-size: 24px;
    }
  }

  /*::v-deep .el-input__prefix {*/
  /*  left: 31px;*/
  /*}*/
}

.user {
  position: absolute;
  left: 85%;
  top: 0;
  display: flex;
  align-items: center;
  width: 200px;
  height: 50px;
  line-height: 50px;
  align-items: center;
}

.remind {
  height: 100%;
  margin-left: 0;

  i {
    font-size: 33px;
  }
}

.userArea {
  // width: 120px;
  height: 100%;
  float: right;

  &-toLogin {
    &-btn {
      padding: 8px 22px;
      cursor: pointer;
      border-radius: 8px;
    }
  }

  .avatar {
    display: inline-block;
    margin-top: 4px;
  }

  i {
    display: inline-block;
    font-size: 32px;
    // color: #fd8c88;
    color: #71b7fd;

    &.man {
      color: #71b7fd;
    }
  }

  .name {
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 83px;
    text-align: center;
    height: 50px;
    line-height: 50px;
  }

  .tag {
    display: inline-block;
    font-size: 14px;
    color: #E28A32;
    padding-left: 5px;
  }
}

// 非通栏二级导航栏
.navson-one {
  max-height: 0px;
  transition: all 0.2s;
  position: absolute;
  background: #ffffff;
  border-radius: 4px;
  width: 120px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 0 !important;
  }

  ul {
    li {
      width: 100%;

      a {
        display: inline-block;
        padding: 7px 0px;
        width: 80%;
        color: inherit;
        font-family: inherit;
        font-size: inherit;
        font-style: inherit;
        text-decoration: inherit;
        font-weight: inherit;
        line-height: inherit;
        text-align: inherit;
        transition: all 0.2s;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }

      &:hover {
        background-color: #4e86ff;
        color: white;
      }
    }
  }
}

// 通栏二级导航栏
.navson {
  position: absolute;
  width: 100% !important;
  display: flex;
  z-index: 999;
  background-color: white;
  overflow: hidden;
  max-height: 0px;
  transition: all 0.2s;
  border: none !important;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: #333333;

  .active-nav {
    a {
      color: var(--background-color);
    }
  }
}

.navson ul {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.navson ul li a {
  display: inline-block;
  padding: 10px 26px;

  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  text-decoration: inherit;
  font-weight: inherit;
  line-height: inherit;
  text-align: inherit;
  background-color: white;
  transition: all 0.2s;
  color: #333333;
}

.navson ul li a:hover {
  color: var(--background-color);
}

.mask {
  transition: all 0.3s;
  position: absolute;
  width: 100%;
  height: 0px;
  background: transparent;
  pointer-events: none;
}

::v-deep .el-carousel {
  height: 100%;

  .el-carousel__container {
    height: 100%;
  }
}

.vdr.active>.tools {
  display: block;
}

div.logo div.vdr {
  position: static;
  border: none;
}

.news {
  width: 60px !important;
}
</style>